import React from 'react';

import InnerHTML from 'components/InnerHTML';

import { useSeoMeta } from 'hooks';
import { Wrapper, Blocks } from './styles';

const SeoMetaTextBlock = () => {
  const { metaText } = useSeoMeta();

  return metaText ? (
    <Wrapper>
      <Blocks>
        <InnerHTML html={metaText} className="InnerHTML" />
      </Blocks>
    </Wrapper>
  ) : null;
};

export default SeoMetaTextBlock;
